/* eslint-disable radix */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from 'reactstrap';
import DeleteModal from '~/components/DeleteModal';
import { Container } from './styles';

function Card({
  form,
  loading,
  setForm,
  handleSubmit,
  subMenuData,
  handleDelete,
}) {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  return (
    <Container>
      <h1>Atualizar Sub Menu: {subMenuData.nome}</h1>
      <Form style={{ width: '100%' }}>
        <Row form>
          <Col md={4}>
            <FormGroup>
              <Label>Nome do sub menu</Label>
              <Input
                type="text"
                placeholder="Insira o nome"
                maxLength={200}
                onChange={(e) => setForm({ ...form, nome: e.target.value })}
                required
                defaultValue={subMenuData.nome}
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>Descrição do sub menu</Label>
              <Input
                type="text"
                defaultValue={subMenuData.descricao}
                placeholder="Insira a descrição"
                maxLength={500}
                onChange={(e) =>
                  setForm({ ...form, descricao: e.target.value })
                }
                required
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>
                <span>(opcional)</span> Nome da imagem
              </Label>
              <Input
                type="text"
                defaultValue={subMenuData.nomE_IMAGEM}
                placeholder="Insira o nome da imagem"
                maxLength={50}
                onChange={(e) =>
                  setForm({ ...form, nomeImagem: e.target.value })
                }
                required
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col md={5}>
            <FormGroup>
              <Label>
                Selecione o tipo de página | Atual:{' '}
                <strong>
                  {subMenuData.tipO_PAGINA === 'O' ? 'Opção' : 'Menu'}
                </strong>
              </Label>
              <Input
                placeholder="Selecione..."
                type="select"
                onChange={(e) =>
                  setForm({ ...form, tipoPagina: e.target.value })
                }
                defaultValue={subMenuData.tipO_PAGINA}
                required
              >
                <option value="M">Menu</option>
                <option value="O">Opção</option>
              </Input>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>Rota do sub menu</Label>
              <Input
                type="text"
                disabled={subMenuData.tipO_PAGINA !== 'O'}
                defaultValue={subMenuData.url}
                placeholder="Insira a rota do sub menu"
                onChange={(e) => setForm({ ...form, url: e.target.value })}
                required
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label for="name">Ordem</Label>
              <Input
                type="number"
                name="ordem"
                id="ordem"
                defaultValue={subMenuData.ordem}
                max={1000}
                min={0}
                onChange={(e) =>
                  setForm({ ...form, ordem: parseInt(e.target.value) })
                }
                required
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col md={4}>
            <FormGroup tag="fieldset">
              <Label>Situação cadastral</Label>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="radio1"
                    onChange={() =>
                      setForm({ ...form, idSituacaoCadastral: 1 })
                    }
                    defaultChecked={subMenuData.iD_SITUACAO_CADASTRAL === 1}
                  />
                  Ativo
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="radio1"
                    onChange={() =>
                      setForm({ ...form, idSituacaoCadastral: 2 })
                    }
                    defaultChecked={subMenuData.iD_SITUACAO_CADASTRAL !== 1}
                  />
                  Inativo
                </Label>
              </FormGroup>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label for="name">Relatório</Label>
              <Input
                type="number"
                name="ordem"
                id="ordem"
                max={1000}
                defaultValue={subMenuData.iD_RELATORIO}
                min={0}
                onChange={(e) =>
                  setForm({ ...form, idRelatorio: parseInt(e.target.value) })
                }
                required
              />
            </FormGroup>
          </Col>
          <Col md={4} />
        </Row>
      </Form>
      {loading ? (
        <section>
          <Button color="primary" disabled className="btn2">
            <Spinner size="sm" color="light" />
          </Button>
          <Button color="danger" disabled outline className="btn1">
            Excluir
          </Button>
        </section>
      ) : (
        <section>
          <Button color="primary" onClick={handleSubmit} className="btn2">
            Atualizar
          </Button>
          <Button outline color="danger" onClick={toggle} className="btn1">
            Excluir
          </Button>
        </section>
      )}
      <DeleteModal
        toggle={toggle}
        modal={modal}
        handleDelete={handleDelete}
        id={subMenuData.id}
        loading={loading}
      />
    </Container>
  );
}

export default Card;
